import { render, staticRenderFns } from "./thirdPartyManagement.vue?vue&type=template&id=ed36e64a&"
import script from "./thirdPartyManagement.vue?vue&type=script&lang=js&"
export * from "./thirdPartyManagement.vue?vue&type=script&lang=js&"
import style0 from "./thirdPartyManagement.vue?vue&type=style&index=0&id=ed36e64a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports